import { Component, OnInit, Input } from '@angular/core';
import { SectionChartContainerService } from './section-chart-container.service';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
  selector: 'fcp-section-chart-container',
  template: `
    <fcp-section-chart
      *ngIf="dataChart"
      [sectionChart]="dataChart"
    ></fcp-section-chart>
  `
})
export class SectionChartContainerComponent implements OnInit {
  @Input() public id;
  public dataChart: Observable<any>;
  constructor(
    private sectionChartContainerService: SectionChartContainerService
  ) {}

  ngOnInit() {
    this.sectionChartContainerService
      .getGraficos(this.id)
      .pipe(take(1))
      .subscribe(res => (this.dataChart = res));
  }
}
